import React from 'react';
import ReactDOM from 'react-dom/client';
import Cookies from 'js-cookie';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Pendo Initialization
(function (apiKey) {
  (function (p, e, n, d, o) {
    var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) {
      o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
    })(v[w]);
    y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
    z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');
  
        // Get user data from Cookies using js-cookie
      const getUserData = () => {
        try {
          const user = JSON.parse(Cookies.get('user') || '{}');
          
          return {
            id: user.id,
            email: Cookies.get('email'),
            role: Cookies.get('role'),
            title: Cookies.get('title'),
            status: Cookies.get('userStatus'),
            kycStatus: Cookies.get('kycStatus'),
            accountId: user.accountId,
            accountName: user.accountName,
            firstName: user.firstName,
            lastName: user.lastName
          };
        } catch {
          return {};
        }
      };

      const userData = getUserData();

      // Initialize Pendo with user data
      window.pendo.initialize({
        visitor: {
          id: userData.id || 'ANONYMOUS-USER',
          email: userData.email || '',
          full_name: userData.firstName && userData.lastName ? 
            `${userData.firstName} ${userData.lastName}` : 'Anonymous',
          role: userData.role || 'anonymous',
          title: userData.title || '',
          status: userData.status || '',
          kyc_status: userData.kycStatus || ''
        },

        account: {
          id: userData.accountId || 'ANONYMOUS-ACCOUNT',
          name: userData.accountName || 'Anonymous Account',
          status: userData.status || '',
          kyc_status: userData.kycStatus || ''
        }
      });

})('0678c035-1930-4139-7743-e942a82e57f2');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
